import { render, staticRenderFns } from "./FUpload.vue?vue&type=template&id=4df20376&lang=html&"
import script from "./FUpload.vue?vue&type=script&lang=js&"
export * from "./FUpload.vue?vue&type=script&lang=js&"
import style0 from "./FUpload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports